import React, { useEffect, useState } from 'react';
import '../ManageProjectsByEmployees.css';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../../utils/axiosInstance';

export const TodaysWorkStatOfSelectedProject = ({ totalDuration }) => {
    const { t } = useTranslation();
    const todayFormatted = formatDate(new Date());

    return (
        <div className='WorkStat-body'>
            <div className='WorkStat-worked-headerbody'>
                <div className='WorkStat-worked-header'>
                    <span>{t("employeeWorkDetails_today")}</span>
                    <span style={{ fontSize: '10px' }}>HH-MM-SS</span>
                </div>
            </div>
            <div className='WorkStat-worked-duration'>
                {totalDuration}
            </div>
            <div className='WorkStat-worked-footer'>
                {todayFormatted}
            </div>
        </div>
    );
};

// Helper function to format date
const formatDate = (date) => {
    const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
    return date.toLocaleDateString('en-US', options);
};

export default TodaysWorkStatOfSelectedProject;
